import { render, staticRenderFns } from "./SingUpForm.vue?vue&type=template&id=b45f678a&scoped=true&"
import script from "./SingUpForm.vue?vue&type=script&lang=ts&"
export * from "./SingUpForm.vue?vue&type=script&lang=ts&"
import style0 from "./SingUpForm.vue?vue&type=style&index=0&id=b45f678a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45f678a",
  null
  
)

export default component.exports